import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 w-full px-4 md:px-6 py-20 md:py-28 flex flex-col items-center text-center">
        <p className="font-brand text-7xl md:text-9xl text-primary-500/25 select-none leading-none">404</p>
        <h1 className="mt-6 text-2xl md:text-3xl font-bold text-foreground-950">这条线索走丢了</h1>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-md">
          你访问的页面不存在，或者已经被合并到其他条目。
        </p>
        <code className="mt-3 text-xs text-foreground-400 break-all">{location.pathname}</code>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line" aria-hidden="true" />
            返回首页
          </Link>
          <Link
            to="/submit"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 text-sm hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            <i className="ri-send-plane-line" aria-hidden="true" />
            我要投稿
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}